import { styled } from '@elliemae/ds-system';
import type { SizingProps } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';

interface StyledListWrapperT {
  minWidth: SizingProps['minWidth'];
  maxHeight?: SizingProps['maxHeight'];
  width: number | string;
  inline?: boolean;
}
export const StyledListWrapper = styled(Grid)<StyledListWrapperT>`
  min-width: ${({ inline, minWidth }) => (inline ? '100%' : `${String(minWidth)}px`)};
  width: ${({ width }) => `${width}px`};
  background-color: #ffffff;
  z-index: 100;
`;

export const StyledCreatableLabel = styled.span`
  font-weight: bold;
  font-style: italic;
`;

export const StyledCreatableValue = styled.span`
  word-break: break-all;
`;

export const StyledNoResultsWrapper = styled.div`
  padding: 14px;
`;
